<template>
	<v-progress-circular v-if="isLoading"></v-progress-circular>
	<v-container v-else class="register-page">
		<div class="register-page__back" v-if="step === 2" @click="toStep1">
			<v-icon class="register-page__back-icon mr-3"> mdi-arrow-left-circle</v-icon>
			<span class="register-page__back-text"> Back </span>
		</div>
		<div
			class="register-page__content"
			v-bind:style="{ maxWidth: step === 1 ? '320px' : '480px' }"
		>
			<h1
				:class="{
					'register-page__title': true,
					'mb-2': singUpMessage,
					'mb-5': !singUpMessage,
				}"
			>
				Sign Up
			</h1>
			<h2 v-if="singUpMessage" class="register-page__subtitle mb-5">
				{{ singUpMessage }}
			</h2>
			<RegisterStep1Form
				v-if="step === 1"
				@submitStep1="handleSubmitStep1"
				:initFields="initFields"
				:categorySettings="categorySettings"
			/>
			<RegisterStep2Form
				v-else
				:initFields="initFields"
				@cacheFields="cacheFields"
				@stepBack="stepBack"
				:categorySettings="categorySettings"
			/>
			<p class="terms-of-use" v-html="policyAndTermText"></p>
		</div>
	</v-container>
</template>

<script>
import RegisterStep1Form from '@/components/Forms/RegisterStep1Form'
import RegisterStep2Form from '@/components/Forms/RegisterStep2Form'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'RegisterPage',
	components: {
		RegisterStep1Form,
		RegisterStep2Form,
	},
	data() {
		return {
			step: 1,
			categorySettings: null,
			fields: {
				user_login: '',
				user_password: '',
				slug: '',
			},
		}
	},
	methods: {
		...mapActions('auth', ['getRegisterCategories']),
		handleSubmitStep1(payload) {
			this.fields = { ...this.fields, ...payload }
			this.step = 2
		},
		toStep1() {
			this.step = 1
		},
		cacheFields(payload) {
			this.fields = payload
		},
		stepBack() {
			this.fields.user_login = ''
			this.fields.user_password = ''
			this.toStep1()
		},
	},
	computed: {
		...mapGetters('settings', ['login']),
		...mapGetters('auth', ['userRegistrationCategories','isLoading']),
		singUpMessage() {
			if (this.categorySettings) {
				return this.categorySettings?.signup_message || 'Use your Professional email address to Sign Up'
			}
			return null
		},
		policyAndTermText() {
			const { license_text_signup: licenseText, signup_button: signUpButtonName } =
			this.login || {}

			const { privacy_policy: policy, terms_of_use: termOfUse } = this.baseCore || {}

			return licenseText
				.replace(/{%login.signup_button%}/g, signUpButtonName)
				.replace(/{%core.privacy_policy%}/g, policy)
				.replace(/{%core.terms_of_use%}/g, termOfUse)
				.replace(/href/g, 'target="_blank"href')
		},
		initFields() {
			return this.fields
		},
	},
	async created() {
		await this.getRegisterCategories()
		const urlParams = new URLSearchParams(window.location.search)
		const slugCategory= urlParams.get("slug")
		const foundCategory = this.userRegistrationCategories.find(cat => cat.slug === slugCategory)
		this.categorySettings = foundCategory.registration_settings
		const slug = this.$route.query.slug
		if (slug) {
			this.fields.slug = slug
		}
	},
}
</script>

<style lang="scss">
.register-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: Montserrat, sans-serif;

	@media (min-width: 781px) {
		overflow-y: auto;
		max-height: calc(100vh - 24px);
	}

	&__title {
		font-size: 36px;
		font-weight: 700;
		color: #4a4a4a;
		line-height: 43.88px;
	}

	&__subtitle {
		font-size: 16px;
		font-weight: 400;
		color: #4a4a4a;
		line-height: 19.5px;
	}

	&__back {
		margin-bottom: 100px;
		align-self: flex-start;
		display: flex;
		align-items: center;
		cursor: pointer;

		&-text {
			font-size: 15px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 18.3px;
			text-decoration: underline;
		}

		&-icon {
			color: var(--accent-color) !important;
		}
	}

	.terms-of-use {
		padding-top: 20px;
		max-width: 420px;
		width: 100%;
		color: #a0a0a0 !important;
		font-size: 12px;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		text-align: left;

		a {
			color: var(--link) !important;
		}
	}
}
</style>
